import template from './top-prompt.hbs';
import style     from 'top-prompt.scss';
import DialogView from 'dialogview';

export default Backbone.View.extend({
    template,
    el: '.topMessage',
    initialize (options) {
        this.listenTo(this.model, 'init', this.init);
        // this.dialog = new DialogView({
        //     el: '#gdprContainer'
        // });
    },
    events: {
        'buttonClick .topMessage__confirm': 'onConfirm',
        'buttonClick .topMessage__dismiss': 'onDismiss'
    },
    getTemplateData () {
        return {
            messagePrompt: "We updated our pricing for new subscriptions on January 9th 2023",
            confirmText: 'Read the full announcement',
            dismissText: 'Dismiss'
        };
    },
    render () {
        this.$el.html(this.template(this.getTemplateData()));
        return this;
    },
    show () {
        this.$el.addClass('topMessage--show');
    },
    hide () {
        this.$el.removeClass('topMessage--show');
    },
    onConfirm (e) {
        window.open('https://blog.irccloud.com/2023-price-increase/');
        // this.dialog.show();
    },
    onDismiss (e) {
        e.preventDefault();
        this.model.setPrompted('pricing_2023');
        this.hide();
    },
    shouldShow () {
        return false;
        // if (this.model.hasBeenPrompted('pricing_2023')) {
        //     return false;
        // }
        // return true;
    },
    init (inited) {
        this.render();
        if (this.shouldShow()) {
            this.show();
            this.trigger('layoutChange');
        }
    }
});



// WEBPACK FOOTER //
// ./app/src/view/top-prompt-view.es6